// React Imports
import * as React from "react";
import {useState, useEffect} from "react";
import {useDispatch, useSelector} from "react-redux";

// Mui Imports
import {deepOrange} from '@mui/material/colors';
import Box from "@mui/material/Box";
import {DataGridPro, GRID_DETAIL_PANEL_TOGGLE_FIELD} from "@mui/x-data-grid-pro";

// App Imports
import {getContractHeaderStandard} from "../../Contract/ContractClient";
import {getTaxHierarchy} from "../../ContractDataPointValue/ContractDataPointValueClient";
import {changeTax} from "./taxSlice";
import {changeRowSelect} from "../../Menus/rowSelectSlice";
import {WorkIssuanceTaxGridColumns} from "./WorkIssuanceTaxGridColumns";
import {changeWorkIssuance} from "../workIssuanceSlice";
import LinearIndeterminate from "../../CommonComponents/Progress";


// main function
export default function WorkIssuanceTaxGrid(props) {

    // ****************** BEGIN STATES ****************************

    const [contracts, setContracts] = useState([]);
    const [contractHeader, setContractHeader] = React.useState([]);
    const [selectorContractName, setSelectorContractName] = React.useState([]);
    const [selectorContractHeader, setSelectorContractHeader] = React.useState([]);

    const [submitting, setSubmitting] = useState(false);
    // ****************** END STATES ****************************


    // *********************** BEGIN STORE ********************************

    const selectorContractId = useSelector((state) => state.workQueueSlc.value.selectedContractId);
    const selectorProductId = useSelector((state) => state.workSlc.value.propertyId);
    const cashState = useSelector((state) => state.workIssuanceSlc.value.cashState);
    const accrualState = useSelector((state) => state.workIssuanceSlc.value.accrualState);
    const liabilityState = useSelector((state) => state.workIssuanceSlc.value.liabilityState);
    const ultimatesState = useSelector((state) => state.workIssuanceSlc.value.ultimatesState);
    const fetchProductId = useSelector((state) => state.workIssuanceSlc.value.fetchProductId);
    const fetchVersionNumber = useSelector((state) => state.workIssuanceSlc.value.fetchVersionNumber);

    // ********************** END STORE ********************************


    // ****************** BEGIN DISPATCH ****************************

    const dispatchData = useDispatch();

    // ****************** END DISPATCH ****************************


    const hideActions = localStorage.getItem('hideActions') === "true";


    // ****************** BEGIN FETCH ****************************

    const fetchContractHeaders = () => {
        if (selectorContractId > 0
        ) {
            getContractHeaderStandard(selectorContractId)

                .then(data => {
                    console.log("My header");
                    console.log(data);
                    setContractHeader(data);
                    setSelectorContractName(data[0].name);
                    setSelectorContractHeader(data[0]);
                })}};

    const fetchTax = () => {
        if (fetchProductId > 0
        ){
            console.log("getTaxHierarchy triggered after passing fetchProductId condition");
            console.log("fetchProductId = ", fetchProductId);
            console.log("cashState = ", cashState);
            console.log("accrualState = ", accrualState);
            console.log("liabilityState = ", liabilityState);
            console.log("ultimatesState = ", ultimatesState);
            setSubmitting(true);
            let calcType = null;

            if (cashState === true) {
                calcType = "Estimated Tax Amount";
            } else if (accrualState === true) {
                calcType = "Accrual Tax Amount";
            } else if (liabilityState === true) {
                calcType = "Liability Tax Amount";
            }
            else if (ultimatesState === true) {
                calcType = "Ultimate Tax Amount";
            }
            getTaxHierarchy(fetchProductId,fetchVersionNumber, calcType)

                .then(data => {
                    console.log(data);
                    setContracts(data);
                    setSubmitting(false);
                })}};

    // ****************** END FETCH ****************************


    // ******************** BEGIN USE EFFECTS *******************

    useEffect(() => {
        console.log("Loading Contracts Header");
        fetchContractHeaders()
    }, []);



    useEffect(() => {
        console.log("tax fetch triggered by grid refresh = true");
        console.log("fetchProductId = ", fetchProductId);
        fetchTax();
        dispatchData(changeWorkIssuance({taxGridRefresh: false}));
    }, [useSelector((state) => state.workIssuanceSlc.value.taxGridRefresh)===true]);


    useEffect(() => {
        setContracts([]);
        dispatchData(changeWorkIssuance({clearData: false}));
    }, [useSelector((state) => state.workIssuanceSlc.value.clearData)===true]);

    // ******************** END USE EFFECTS *******************


    // ***************** BEGIN CONTROLS ***************************

    function handleMousedRow(data) {
        console.log('moused row');
        console.log(data);
        dispatchData(changeRowSelect({contractId: data.contractId, contractSectionId: data.contractSectionId,
            cdpId: data.cdpId, cdpvId: data.cdpvId, cdpvfId: null, csfId: null}));
        console.log("cdp id");
    }

    // *************** END CONTROLS *******************************


    function DetailPanelContent() {
        return (
            <h2>TEST</h2>
            // <div>{id}</div>
        )}

    const getDetailPanelHeight = React.useCallback(() => 300, []);

    const getDetailPanelContent = React.useCallback(
        ({ row }) => <DetailPanelContent row={contracts.id} />,
        [],
    );


    const getTreeDataPath = (contracts) => contracts.hierarchy.split(',');

    const groupingColDef = {
        hideDescendantCount: true,
        width: 330,
    };

    // ****************** BEGIN RETURN ****************************

    return (
        <div>
            {submitting && <LinearIndeterminate/>}
        <Box sx={{ height:800 , width: '100%',

            '& .level--1': {backgroundColor: "rgb(30,144,255)"},//https://html-color.codes/blue dodger blue
            '& .level--2': {backgroundColor: "rgb(69,177,232)"},//https://html-color.codes/blue picton blue
            '& .level--3': {backgroundColor: "rgb(135,206,250)"},//https://html-color.codes/blue lightskyblue
            '& .level--4': {backgroundColor: "rgb(137,207,240)"},//https://html-color.codes/blue baby blue
            '& .level--5': {backgroundColor: "rgb(173,216,230)"},//https://html-color.codes/blue light blue
            '& .level--6': {backgroundColor: "rgb(135,206,235)"},//https://html-color.codes/blue skyblue
            '& .level--7': {backgroundColor: "rgb(231,254,255)"},//https://html-color.codes/blue bubbles
            '& .level--8': {backgroundColor: "rgb(244,240,236)"},//https://html-color.codes/grey isabelline
            '& .level--9': {backgroundColor: "rgb(250,250,250)"},//custom
            '& .level--10': {backgroundColor: "rgb(255,255,255)"},//custom
        }}
        >
            <div>

            </div>

            <DataGridPro
                experimentalFeatures={{ newEditingApi: true }}
                sx={{
                    '& .MuiDataGrid-detailPanel': {
                        backgroundColor: deepOrange[100],
                    },
                }}
                initialState={{
                    sorting: {
                        sortModel: [{ field: 'hierarchyOrder', sort: 'asc' }],
                    }
                    // filter: {
                    //     items: [
                    //         {
                    //             columnField: 'id',
                    //             operatorValue: '==',
                    //             value: '30'
                    //         }]
                    // }
                }}
                treeData
                aria-label={"Contracts"}
                rows={contracts}
                getRowClassName={(contracts) => `level--${contracts.row.hierarchyLevel}`}
                getDetailPanelContent={({ row }) => (
                    // <Box sx={{ p: 2, flexGrow: 1,
                    //     bgcolor: deepOrange[100]
                    //     // backgroundColor: "rgb(255,204,153)"
                    // }}>
                    //     {`Expression: ${row.expression}`}
                    //     <br/>
                    //     <br/>
                    //     {`Translation: ${row.expressionTranslation}`}
                    //     <br/>
                    //     <br/>
                    //     {`Raw Expression: ${row.rawExpression}`}
                    // </Box>
                    <Box sx={{ p: 2, flexGrow: 1,
                    bgcolor: deepOrange[100]
                }}>
                        <Box sx={{ml: 128}}>
                <strong>Payment Method:</strong> {row.paymentMethodName}
                        </Box>
                            {/*<br/>*/}
                    <br/>
                        <Box sx={{ml: 128}}>
                            <strong>Payee Type:</strong> {row.payeeTypeName}
                        </Box>
                    <br/>
                        <Box sx={{ml: 128}}>
                            <strong>Tax Exempt:</strong> {row.taxExemptName}
                        </Box>
                    </Box>
                )}
                getDetailPanelHeight={getDetailPanelHeight}
                // getDetailPanelHeight={({ row }) => {
                //     const lineHeight = 24;
                //     const padding = 32;
                //     const brSpacing = 32; // for 2 <br/><br/> lines
                //     const lines = [
                //         row.paymentMethodName,
                //         row.payeeTypeName,
                //         row.taxExemptName,
                //     ].filter(Boolean).length;
                //
                //     return padding + lines * lineHeight + brSpacing;
                // }}
                disableDensitySelector={true}
                disableColumnSelector={true}
                // columns={columns(fetchTax)}
                columns={WorkIssuanceTaxGridColumns({
                    hideActions,
                    handleMousedRow,
                    cashState,
                    accrualState,
                    liabilityState,
                    ultimatesState
                })}
                density={"compact"}
                pageSize={20}
                rowsPerPageOptions={[20]}
                rowKey={contract => contract.id}
                getTreeDataPath={getTreeDataPath}
                groupingColDef={groupingColDef}
                components={{
                    // Toolbar: CustomToolbar,
                    // Footer: CustomFooter,
                }}
            />
        </Box>
        </div>
    );

    // ****************** END RETURN ****************************

}




